import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackSyncFragment = { __typename?: 'OrgGuestFeedbackSync', id: string, startedAt: string, completedAt?: string | null, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string }>, orgGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackIntegration', id: string, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string } | null } };

export type OrgGuestFeedbackSyncsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgGuestFeedbackSyncsQuery = { __typename?: 'Query', OrgGuestFeedbackSyncs: { __typename?: 'OrgGuestFeedbackSyncs', totalCount: number, objects: Array<{ __typename?: 'OrgGuestFeedbackSync', id: string, startedAt: string, completedAt?: string | null, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string }>, orgGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackIntegration', id: string, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string } | null } }> } };

export const OrgGuestFeedbackSyncFragmentDoc = gql`
    fragment OrgGuestFeedbackSync on OrgGuestFeedbackSync {
  id
  startedAt
  completedAt
  feedbacks {
    id
  }
  orgGuestFeedbackIntegration {
    id
    googleBusinessConfig {
      id
    }
    ovationIntegrationConfig {
      id
    }
    tattleIntegrationConfig {
      id
    }
  }
}
    `;
export const OrgGuestFeedbackSyncsDocument = gql`
    query OrgGuestFeedbackSyncs {
  OrgGuestFeedbackSyncs {
    objects {
      ...OrgGuestFeedbackSync
    }
    totalCount
  }
}
    ${OrgGuestFeedbackSyncFragmentDoc}`;

/**
 * __useOrgGuestFeedbackSyncsQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgGuestFeedbackSyncsQuery(baseOptions?: Apollo.QueryHookOptions<OrgGuestFeedbackSyncsQuery, OrgGuestFeedbackSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackSyncsQuery, OrgGuestFeedbackSyncsQueryVariables>(OrgGuestFeedbackSyncsDocument, options);
      }
export function useOrgGuestFeedbackSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackSyncsQuery, OrgGuestFeedbackSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackSyncsQuery, OrgGuestFeedbackSyncsQueryVariables>(OrgGuestFeedbackSyncsDocument, options);
        }
export type OrgGuestFeedbackSyncsQueryHookResult = ReturnType<typeof useOrgGuestFeedbackSyncsQuery>;
export type OrgGuestFeedbackSyncsLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackSyncsLazyQuery>;
export type OrgGuestFeedbackSyncsQueryResult = Apollo.QueryResult<OrgGuestFeedbackSyncsQuery, OrgGuestFeedbackSyncsQueryVariables>;